
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"33","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_222_4122)"}},[_c('path',{attrs:{"d":"M11.5 19.943a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM20.5 19.943a1.5 1.5 0 100-3 1.5 1.5 0 000 3z","fill":"#94A3B8"}}),_c('path',{attrs:{"d":"M19.18 10.155l.625-2.454a1.013 1.013 0 011.151-.75l4.505.742a1.01 1.01 0 01.818.75L29.97 22.99a1 1 0 01-.569 1.155l-8.375 3.712a1.019 1.019 0 01-1.375-.57l-1.276-3.461M12.82 10.155L12.195 7.7a1.013 1.013 0 00-1.151-.75l-4.505.742a1.01 1.01 0 00-.818.75l-3.69 14.544a1 1 0 00.568 1.155l8.375 3.713a1.018 1.018 0 001.375-.57l1.276-3.46","stroke":"#94A3B8","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 10.732a22.368 22.368 0 016-.788c2.026-.01 4.045.255 6 .788M22 23.154a22.368 22.368 0 01-6 .789 22.368 22.368 0 01-6-.789","stroke":"#94A3B8","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_222_4122"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .943)","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    